// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"fbbf9165","275":"8fbab215","716":"4358f321"}[chunkId] + ".chunk.css";
};